import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { SetupService } from '@core/services/setup';
import { positions, formatTypes, DEPARTMENTS } from '@core/constants';

type PositionsType =
    | 'MAIN_SCREEN'
    | 'MAIN_PAGE'
    | 'NEWS_START'
    | 'NEWS_END'
    | 'DEPARTMENT_SIDEBAR'
    | 'TOURNAMENTS'
    | 'DEPARTMENT_HEADER'
    | 'FEDERATION'
    | 'CLUBS'
    | 'CONTACT';

type FormatType = 'BNTENNISTOOL01' | 'BNTENNISTOOL02' | 'BNTENNISTOOL03' | 'BNTENNISTOOL04' | 'BNTENNISTOOL05';

type DirectionType = 'vertical' | 'horizontal';

type DepartmentsType = 'DEPARTMENT_TYPE_YOUTH' |
'DEPARTMENT_TYPE_WHEELCHAIR' |
'DEPARTMENT_TYPE_SENIOR' |
'DEPARTMENT_TYPE_PROFESSIONAL' |
'DEPARTMENT_TYPE_CLASSES' |
'DEPARTMENT_TYPE_COACHTRAINING' |
'DEPARTMENT_TYPE_ARBITRATION' |
'DEPARTMENT_TYPE_INSTITUTIONAL' |
'DEPARTMENT_TYPE_UNIVERSITY' |
'DEPARTMENT_TYPE_ENTITY' |
'DEPARTMENT_TYPE_BEACHTENNIS' |
'DEPARTMENT_TYPE_KIDS' |
'DEPARTMENT_TYPE_SERVICES' |
'DEPARTMENT_TYPE_COURTS' |
'DEPARTMENT_TYPE_TENNIS10' |
'DEPARTMENT_TYPE_BANANABOWL' |
'DEPARTMENT_TYPE_WTN' |
'DEPARTMENT_TYPE_FAQ';

@Component({
    selector: 'app-shared-partner',
    templateUrl: './shared-partner.component.html',
    styleUrls: ['./shared-partner.component.scss'],
})
export class SharedPartnerComponent implements OnInit {
    subscription: Subscription;
    partners = [];
    @Input() hideParentIfNotFound: boolean = true;
    @Input() position: PositionsType;
    @Input() formatType: FormatType;
    @Input() chunks: number;
    @Input() direction: DirectionType;
    @Input() padding: number = 0;
    @Input() fullWidth: boolean;
    @Input() depto: DepartmentsType;
    arrayChunks: Array<number>;
    heightCarousel: number;
    heightPartner: number;
    widthCarousel: number;
    widthPartner: number;

    constructor(private setupService: SetupService, private host: ElementRef, private renderer: Renderer2) {}

    get partnersPerGroup(): number {
        if (!this.chunks || !this.widthPartner) return 1;
        const qtByWidth = Math.floor(window.innerWidth / (parseInt(this.widthPartner.toString()) + 10));
        const chunkSize = parseInt(this.chunks.toString());
        const result = chunkSize < qtByWidth ? chunkSize : qtByWidth;
        return result;
    }

    get partnersGroups(): number[] {
        return Array(Math.ceil(this.partners.length / this.partnersPerGroup))
            .fill(0)
            .map((_, i) => i);
    }

    ngOnInit(): void {
        if (this.position && this.formatType) {
            this.subscription = this.setupService
                .getPartners(positions[this.position], formatTypes[this.formatType], undefined, this.depto ? parseInt(DEPARTMENTS[this.depto]) : null)
                .subscribe((response: any) => {
                    const chunkSize = this.chunks ? parseInt(this.chunks.toString()) : 0;
                    this.partners = response.registers.data;

                    this.widthPartner = response.registers.bannerMeta.width;
                    this.widthCarousel =
                        this.chunks && this.direction === 'horizontal'
                            ? parseInt(response.registers.bannerMeta.width) * chunkSize + chunkSize * 8
                            : response.registers.bannerMeta.width;
                    this.heightPartner = response.registers.bannerMeta.height;
                    this.heightCarousel =
                        this.chunks && this.direction === 'vertical'
                            ? parseInt(response.registers.bannerMeta.height) * chunkSize + chunkSize * 8
                            : response.registers.bannerMeta.height;
                    if (!this.partners?.length && this.hideParentIfNotFound) {
                        this.hideParent();
                    }
                });
        }
    }

    hideParent() {
        const parentElementToHide = this.host.nativeElement.parentElement.parentElement;
        this.renderer.setStyle(parentElementToHide, 'display', 'none');
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
